module.exports = __webpack_public_path__ + "static/media/pvcanvas.c513df5c.png";